import React from 'react'
import { Card } from 'react-bootstrap'
import { User } from '../../../types/models/user'

// Add SVG icons for stats
const UsersIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" className="text-primary">
    <path d="M16 17v2H2v-2s0-4 7-4 7 4 7 4m-7-6a4 4 0 0 0 4-4 4 4 0 0 0-4-4 4 4 0 0 0-4 4 4 4 0 0 0 4 4m8-1h6v2h-6v-2m0 4h6v2h-6v-2m0-8h6v2h-6V6Z" />
  </svg>
)

const ActiveUsersIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" className="text-success">
    <path d="M12 4a4 4 0 0 1 4 4 4 4 0 0 1-4 4 4 4 0 0 1-4-4 4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4m4.5-2.5 1.79 1.79L23 13.5 21.21 15l-3.21-3.21L16.5 11.5l3.71 3.71-1.79 1.79-3.71-3.71 1.79-1.79Z" />
  </svg>
)

const NewUsersIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" className="text-warning">
    <path d="M15 14c-2.67 0-8 1.33-8 4v2h16v-2c0-2.67-5.33-4-8-4m-9-4V7H4v3H1v2h3v3h2v-3h3v-2m6 2a4 4 0 0 0 4-4 4 4 0 0 0-4-4 4 4 0 0 0-4 4 4 4 0 0 0 4 4Z" />
  </svg>
)

interface StatsCardsProps {
  users: User[]
  layout?: 'vertical' | 'horizontal'
}

const StatsCards: React.FC<StatsCardsProps> = ({ users, layout = 'vertical' }) => {
  const regularUsers = users.filter((user) => user.username !== 'admin')
  const totalUsers = regularUsers.length

  const recentlyActiveUsers = regularUsers.filter((user) => {
    const lastLogin = new Date(user.last_login || '')
    const oneWeekAgo = new Date()
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7)
    return lastLogin > oneWeekAgo
  }).length

  const newUsersThisMonth = regularUsers.filter((user) => {
    const createdAt = new Date(user.created_at)
    const startOfMonth = new Date()
    startOfMonth.setDate(1)
    startOfMonth.setHours(0, 0, 0, 0)
    return createdAt >= startOfMonth
  }).length

  const containerClass = layout === 'horizontal' ? 'd-flex flex-row gap-3' : ''
  const cardClass = layout === 'horizontal' ? 'flex-fill' : 'mb-3'

  return (
    <div className={containerClass}>
      <Card bg="dark" text="white" className={cardClass}>
        <Card.Body className="d-flex align-items-center p-3">
          <div className="bg-primary bg-opacity-25 rounded-circle p-3 me-3">
            <UsersIcon />
          </div>
          <div>
            <h6 className="text-muted mb-1">Total Users</h6>
            <p className="text-light small mb-0">Total number of registered users</p>
            <h3 className="mb-0">{totalUsers}</h3>
          </div>
        </Card.Body>
      </Card>

      <Card bg="dark" text="white" className={cardClass}>
        <Card.Body className="d-flex align-items-center p-3">
          <div className="bg-success bg-opacity-25 rounded-circle p-3 me-3">
            <ActiveUsersIcon />
          </div>
          <div>
            <h6 className="text-muted mb-1">Recently Active</h6>
            <p className="text-light small mb-0">Users active in the last 7 days</p>
            <h3 className="mb-0">{recentlyActiveUsers}</h3>
          </div>
        </Card.Body>
      </Card>

      <Card bg="dark" text="white" className={cardClass}>
        <Card.Body className="d-flex align-items-center p-3">
          <div className="bg-warning bg-opacity-25 rounded-circle p-3 me-3">
            <NewUsersIcon />
          </div>
          <div>
            <h6 className="text-muted mb-1">New This Month</h6>
            <p className="text-light small mb-0">Users who joined this month</p>
            <h3 className="mb-0">{newUsersThisMonth}</h3>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

export default StatsCards
